<app-grade-unit-hero
  [card]="gradeUnitListItem"
  color="PURPLE"
  [actions]="displayActions"
  [showStartDate]="false"
></app-grade-unit-hero>

<div class="grid-container">
  <ng-container *ngFor="let day of days; trackBy: byId">
    <div class="grid-item">
      <app-grade-unit-day-assignment-card
        [gradeUnitDay]="day"
        [unitNumber]="unitNumber"
        [gradeNumber]="gradeNumber"
        [displayActions]="false"
        [allowEdit]="false"
        [showDueDate]="false"
        [isTeacher]="false"
        [isAssignment]="false"
        (refresh)="onRefresh($event)"
      ></app-grade-unit-day-assignment-card>
    </div>
  </ng-container>
</div>
